import { Portfolio } from "types/Transactions";
import { ActionType, getType } from "typesafe-actions";
import { sums } from "utility/sums";
import * as transactiosnActions from "./transactionsActions";

export interface TransactionsState {
  loading?: boolean;
  data?: Portfolio[];
  error?: string;
}

export type TransactionsActions = ActionType<typeof transactiosnActions>;

export default function transactions(
  state: TransactionsState = {},
  action: TransactionsActions
) {
  switch (action.type) {
    case getType(transactiosnActions.load):
      return { ...state, loading: true };
    case getType(transactiosnActions.loadSuccess):
      const data = action.data?.map((d) => ({ ...d, Sums: sums(d) }));
      return { ...state, loading: false, data, error: undefined };
    case getType(transactiosnActions.loadFail):
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
